define(['jquery','components/dropdown', 'core/utilities'],
    function ($,DD,utilities) {
        let googleWrapper = document.querySelector(".google-wrapper")
        let googleWrapperData = googleWrapper ? googleWrapper.dataset : {};

        var feedback = {
            stored_score: undefined,
            nodes: {
                $feedbackForm: null,
                $select: null,
                $submitButton: null,
                $textarea: null,
                $charCount: null
            },
            formatMessage: function (message) {
                message = message.trim();
                var question = message.slice(-1);
                return question === "?" ? message.slice(0,-1) : message;
            },
            enableDisableSubmit: function (e) {
                var score = feedback.nodes.$select.val();
                var val = feedback.nodes.$textarea.val();
                var l = val.length;
                console.log(feedback.nodes.$charCount);
                feedback.nodes.$charCount.text(1000-l);
                if (l > 950) {
                    feedback.nodes.$textarea.addClass("red");
                } else {
                    feedback.nodes.$textarea.removeClass("red");
                }
                if ( score != feedback.stored_score || val) {
                    feedback.nodes.$submitButton.prop('disabled', false);
                } else {
                    feedback.nodes.$submitButton.prop('disabled', true);
                }
            },
            fallbackCopyTextToClipboard: function(text) {
                var textArea = document.createElement("textarea");
                textArea.value = text;
              
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
              
                try {
                  var successful = document.execCommand('copy');
                  var msg = successful ? 'successful' : 'unsuccessful';
                  console.log('Fallback: Copying text command was ' + msg);
                } catch (err) {
                  console.error('Fallback: Could not copy text', err);
                }
              
                document.body.removeChild(textArea);
              },
              copyTextToClipboard: function(text) {
                if (!navigator.clipboard) {
                    feedback.fallbackCopyTextToClipboard(text);
                  return;
                }
                navigator.clipboard.writeText(text).then(function() {
                  console.log('Async: Copying to clipboard was successful!');
                }, function(err) {
                  console.error('Async: Could not copy text: ', err);
                });
              }
        };
        return {

            init: function () {

                feedback.nodes.$feedbackForm = $('#feedback-form');
                feedback.nodes.$charCount = $('.char-count_js');
                feedback.nodes.$submitButton = feedback.nodes.$feedbackForm.find("input[type=submit]");
                feedback.nodes.$textarea = feedback.nodes.$feedbackForm.find(".feedback-comment");
                feedback.nodes.$charCount.text(1000);
                let score = document.querySelector("#score");

                var $header = $('#header');

                var confirmationMsg = $(".temporary-message");

                setTimeout(() => {
                    confirmationMsg.addClass("disabled");
                }, 3000)

                $header.html(feedback.formatMessage(utilities.sanitizeData($header.text())) + " <span display: inline-block;>" + score.outerHTML + " ?</span>");

                score.style.display = "none";

                let customSelect = $header[0].querySelector('.custom-select');
                let marketingPermissionsWrapper = document.querySelector(".marketing-permissions-wrapper")
                let initialScore = document.querySelector(".feedback-select option[selected='selected']").innerText * 1;
                let marketingCheckbox = document.querySelector("#id_has_marketing_permission");
                let googleCheckbox = document.querySelector("#id_ready_for_google_reviews");
                let marketingCheckboxState = false;
                let googleCheckboxState = false;

                if(marketingPermissionsWrapper) {
                    if(initialScore < 9) marketingPermissionsWrapper.classList.add("hide");
                }      
                
                if(googleWrapper) {
                    googleWrapper.classList.add("hide");

                    if(googleWrapperData.promoterReviews || googleWrapperData.passiveReviews || googleWrapperData.detractorReviews) { 
                        if(googleWrapperData.promoterReviews === "True" && initialScore >= 9) googleWrapper.classList.remove("hide");
                        if(googleWrapperData.passiveReviews === "True" && (initialScore === 7 || initialScore === 8)) googleWrapper.classList.remove("hide");
                        if(googleWrapperData.detractorReviews === "True" && initialScore <= 6) googleWrapper.classList.remove("hide");
                    } else {
                        // backwards compatibility
                        if(initialScore >= 9) googleWrapper.classList.remove("hide");
                    }
                }

                if(marketingCheckbox) {
                    marketingCheckbox.addEventListener("change", event => {
                        marketingCheckboxState = event.target.checked;
                    });
                }

                if(googleCheckbox) {
                    googleCheckbox.addEventListener("change", event => {
                        googleCheckboxState = event.target.checked; 
                    });
                }

                DD(customSelect, (value) => {
                    let disableGoogleCheckbox = () => {
                        googleWrapper.classList.add("hide")
                        if(googleCheckbox) googleCheckbox.checked = false;
                    }

                     let enableGooogleCheckbox = () => {
                        googleWrapper.classList.remove("hide")
                        if(googleCheckbox) googleCheckbox.checked = googleCheckboxState;
                     }

                     let disableMarketingCheckbox = () => {
                        marketingPermissionsWrapper.classList.add("hide")
                        if(marketingCheckbox) marketingCheckbox.checked = false;
                    }

                     let enableMarketingCheckbox = () => {
                        marketingPermissionsWrapper.classList.remove("hide")
                        if(marketingCheckbox) marketingCheckbox.checked = marketingCheckboxState;
                     }

                    if(googleWrapper) {
                        disableGoogleCheckbox();
                    
                        // show google checkbox based on score and configuration
                        if(googleWrapperData.promoterReviews || googleWrapperData.passiveReviews || googleWrapperData.detractorReviews) { 
                            if(googleWrapperData.promoterReviews === "True" && value >= 9) enableGooogleCheckbox();
                            if(googleWrapperData.passiveReviews === "True" && (value == 7 || value == 8)) enableGooogleCheckbox();
                            if(googleWrapperData.detractorReviews === "True" && value <= 6) enableGooogleCheckbox();
                        } else {
                            // backwards compatibility
                            if(value >= 9) {
                                enableGooogleCheckbox();
                            }
                        }
                    }

                    // only show marketing permission options for scores of 9 or 10
                    if(marketingPermissionsWrapper) {
                        if(value >= 9) {
                            enableMarketingCheckbox();
                        } else {
                            disableMarketingCheckbox();
                        }
                    }
                });

                document.querySelector(".feedback-form .feedback-select").classList.remove("hide");

                feedback.nodes.$select = feedback.nodes.$feedbackForm.find("select");

                feedback.stored_score = feedback.nodes.$select.val();

                // feedback.nodes.$textarea.on('change keyup paste', feedback.enableDisableSubmit);

                let xmlhttp = new XMLHttpRequest();
                xmlhttp.open("GET", feedback.nodes.$feedbackForm.data("submit_url"), true);
                xmlhttp.send();


                feedback.nodes.$feedbackForm[0].addEventListener("submit", function(event) {
                    event.preventDefault();
                    const xhr = new XMLHttpRequest();
                    const fd = new FormData(feedback.nodes.$feedbackForm[0]);

                    xhr.addEventListener("load", function(event) {
                      document.write( event.target.responseText );
                    } );
                    xhr.addEventListener("error", function(event) {
                      document.write(event.target.responseText);
                    } );
                    xhr.open("POST", feedback.nodes.$feedbackForm.data("submit_url"));
                    xhr.send(fd);
                });


                feedback.nodes.$submitButton[0].addEventListener("click", () => {
                    // copy comment to clipboard if submitting to google
                    if(googleCheckbox && googleCheckbox.checked) {
                        feedback.copyTextToClipboard(feedback.nodes.$textarea[0].value);
                    }
                    if (feedback.nodes.$textarea[0].value === '') {
                        if(marketingCheckbox) marketingCheckbox.checked = false
                    }
                })

            }
        }
    }
);
